var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuslesenImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 480",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "50%",
    x2: "50%",
    y2: "93.187%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    d: "m471.6 186.28c-24.198 0-43.815 19.616-43.815 43.815s19.616 43.815 43.815 43.815c9.2802 0 17.887-2.8852 24.971-7.8074l56.428 62.902c5.2083 5.0544 12.79-2.7581 7.5815-7.8124l-55.923-62.339c6.7003-7.6955 10.758-17.753 10.758-28.758 0-24.198-19.616-43.815-43.815-43.815z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3",
    x: -0.17838,
    y: -0.16625,
    width: 1.3791,
    height: 1.3741
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 480,
    display: "none",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.8 268.48) rotate(180) translate(-375 -183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    transform: "translate(375.05 182.68) rotate(180) translate(-375.05 -182.68)",
    d: "m749.2 365.08c0-255.72-118.44-364.8-374.15-364.8s-374.15 109.08-374.15 364.8h748.31z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 568,
    cy: 54.282,
    r: 10.8,
    fill: "#E5EEFF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 689.2,
    cy: 175.48,
    r: 7.2,
    fill: "#F2F5FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    transform: "translate(658 278.68) rotate(150) translate(-658 -278.68)",
    d: "m649.35 281.55c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.415-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#C4D2ED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 338.68,
    r: 7.2,
    fill: "#D7DBE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.567 231.15c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.415-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#D9E4F7"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(139.61 93.882) rotate(163) translate(-139.61 -93.882)",
    d: "m134.08 96.213c-1.9825-6.3548 6.1953-11.464 10.284-5.7318 3.7172 5.2334-2.4781 11.339-7.8061 8.5977-2.1064-1.1214-3.965 2.1183-1.8586 3.2397 9.0451 4.735 18.958-5.981 12.391-14.33-6.6909-8.5977-19.701-0.87223-16.603 9.2207 0.74344 2.2429 4.3367 1.3706 3.5933-0.99684z",
    fill: "#C7D5EE"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(617.2 144.28) rotate(-15) translate(-617.2 -144.28)",
    d: "m603.36 150.11c-4.9562-15.887 15.488-28.659 25.711-14.33 9.293 13.083-6.1953 28.348-19.515 21.494-5.266-2.8036-9.9125 5.2957-4.6465 8.0993 22.613 11.837 47.394-14.953 30.977-35.824-16.727-21.494-49.253-2.1806-41.509 23.052 1.8586 5.6072 10.842 3.4266 8.9832-2.4921z",
    fill: "#F3F6FE"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.02 84)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 7.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    transform: "translate(116.99 159.96) rotate(-6) translate(-116.99 -159.96)",
    d: "m218.5 37.222 3.0095 213.63v21.395c0 6.8925-5.5875 12.48-12.48 12.48h-184.08c-6.8925 0-12.48-5.5875-12.48-12.48v-230.81c0-3.4463 2.7937-6.24 6.24-6.24h0.065307l15.252 0.15998 42.42 0.8714",
    fill: "#fff",
    stroke: "#5374A5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lines",
    transform: "translate(104.96 143.66) rotate(-6) translate(-104.96 -143.66)",
    d: "m37.88 84.384h81.12m-81.12 37.44h134.16m-134.16 40.56h134.16m-134.16 40.56h134.16",
    stroke: "#C5D2ED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "m231.88 3.9c2.2746 0 4.4562 0.90323 6.0651 2.5111l41.943 41.917c1.6102 1.6092 2.5149 3.7924 2.5149 6.0689v195.2c0 2.3693-0.96035 4.5143-2.513 6.067-1.5527 1.5527-3.6977 2.513-6.067 2.513h-184.08c-2.3693 0-4.5143-0.96035-6.067-2.513-1.5527-1.5527-2.513-3.6977-2.513-6.067v-237.12c0-2.3693 0.96035-4.5143 2.513-6.067 1.5527-1.5527 3.6977-2.513 6.067-2.513z",
    fill: "#fff",
    stroke: "#5374A5"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 93.6,
    width: 91.2,
    height: 132,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.26 7.4968v36.183c0 5.1694 4.1906 9.36 9.36 9.36h24.753",
    stroke: "#5374A5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.8
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5374A5",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m321.6 118.24c0-3.0062 2.437-5.4432 5.4432-5.4432s5.4432 2.437 5.4432 5.4432v192.3c0 3.0062-2.437 5.4432-5.4432 5.4432s-5.4432-2.437-5.4432-5.4432v-192.3z",
    fill: "#5374A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.84 118.32c0-3.0062 2.437-5.4432 5.4432-5.4432 3.0062 0 5.4432 2.437 5.4432 5.4432v83.512c0 3.0062-2.437 5.4432-5.4432 5.4432-3.0062 0-5.4432-2.437-5.4432-5.4432v-83.512z",
    fill: "#79A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(471.6 230.09) scale(-1 1) translate(-471.6 -230.09)",
    d: "m471.6 263.02c18.186 0 32.928-14.742 32.928-32.928 0-18.186-14.742-32.928-32.928-32.928-18.186 0-32.928 14.742-32.928 32.928 0 18.186 14.742 32.928 32.928 32.928z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuslesenImg);
export default __webpack_public_path__ + "static/media/Auslesen_img.07d86f1641d78d424af5de8a133eeedd.svg";
export { ForwardRef as ReactComponent };